import { TaskStatus } from './TaskStatus';
var defaultParams = {
    todo: 0,
    finished: 0,
    timeSpent: 0,
    timePlanned: 0,
    workload: 0,
    spentByTasks: [],
    sprintProgress: 0,
    projectChartData: [],
    taskChartData: {}
};
var Statistic = /** @class */ (function () {
    function Statistic(from) {
        if (from === void 0) { from = defaultParams; }
        var _this = this;
        this.todo = from.todo;
        this.finished = from.finished;
        this.timeSpent = from.timeSpent;
        this.timePlanned = from.timePlanned;
        this.workload = from.workload;
        this.spentByTasks = from.spentByTasks;
        this.sprintProgress = from.sprintProgress;
        this.projectChartData = from.projectChartData;
        this.taskChartData = {};
        Object.keys(from.taskChartData).forEach(function (key) {
            _this.taskChartData[TaskStatus.stringify(parseInt(key, 10))] = from.taskChartData[key];
        });
    }
    Statistic.prototype.getSprintStatus = function () {
        if (this.sprintProgress === 0) {
            return 'Tervezett';
        }
        if (this.sprintProgress === 100) {
            return 'Befejeződött';
        }
        return this.sprintProgress + ' %';
    };
    return Statistic;
}());
export default Statistic;



//////////////////
// WEBPACK FOOTER
// ./src/models/Statistic.ts
// module id = 363
// module chunks = 0